<div class="logbook-search-filters">
    <!-- button for open filters -->
    <app-helpers-search-filters-menu
      [filters]="filtersMenu"
      (chooseFilter)="onSelectFilter($event)"
   ></app-helpers-search-filters-menu>

   <!-- dashboard filters -->
   <app-helpers-search-filters-logbook-events-main
      *ngIf="selectedFilter ==  'event'"
      [available]="availableEvents"
      [applied]="appliedFilters"
      (apply)="onApplyFilter($event)"
    ></app-helpers-search-filters-logbook-events-main>
    <app-helpers-search-filters-users-main
      *ngIf="selectedFilter == 'user'"
      [available]="availableUsers"
      [applied]="appliedFilters"
      (apply)="onApplyFilter($event)"
    ></app-helpers-search-filters-users-main>
    <!-- maybe more filters here -->
</div>
